import Icon from "../../../../components/base/Icon";


interface IProps {
    selected: boolean
    onClick: () => void
}

// Eye-catching "pay with a new card" row shared by the subscription and wallet pay drawers.
// Selecting it sends the user to Stripe hosted Checkout to enter a new card and pay in one step.
export default function NewCardOption(props: IProps) {
    return (
        <div
            className={`d-flex align-items-center p-4 rounded border cursor-pointer ${props.selected ? "border-primary bg-light-primary" : "border-gray-300"}`}
            onClick={props.onClick}>
            <div className="symbol symbol-40px me-3">
                <span className="symbol-label bg-light-primary">
                    <Icon icon="credit-card" type="solid" className="text-primary" size={18} />
                </span>
            </div>
            <div className="flex-grow-1">
                <div className="fw-bold text-gray-800">Pay with a new card</div>
                <div className="text-gray-500 fs-8">Enter your card on Stripe — you can save it too</div>
            </div>
            <div className="ms-auto">
                <Icon
                    icon={props.selected ? "circle-check" : "circle"}
                    type="solid"
                    size={20}
                    className={props.selected ? "text-primary" : "text-gray-400"} />
            </div>
        </div>
    )
}
